import { render, staticRenderFns } from "./customEditor.vue?vue&type=template&id=61554bf2&scoped=true&"
import script from "./customEditor.vue?vue&type=script&lang=js&"
export * from "./customEditor.vue?vue&type=script&lang=js&"
import style0 from "./customEditor.vue?vue&type=style&index=0&id=61554bf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61554bf2",
  null
  
)

export default component.exports